var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secondarymenu"},[_c('nav',_vm._l((_vm.sections),function(section,index){return (!section.hidden)?_c('router-link',{key:index,attrs:{"to":section.slug}},[_c('span',[_vm._v(_vm._s(section.title))])]):_vm._e()}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }